/**
 * Garment Order status — labels + tones (ADR-0039, ADR-0042). Colour is always paired
 * with a shape/dot by the badge renderer; never colour-only.
 */
import type { StatusTone } from "@flint/ui";

export type GarmentOrderStatus = "open" | "accepted" | "linked" | "closed" | "cancelled";

const LABEL: Record<GarmentOrderStatus, string> = {
  open: "Open",
  accepted: "Accepted",
  linked: "Style linked",
  closed: "Closed",
  cancelled: "Cancelled",
};

const TONE: Record<GarmentOrderStatus, StatusTone> = {
  open: "warn", // awaiting acceptance — the actionable state
  accepted: "sky", // committed; tech pack generation unlocked
  linked: "sky",
  closed: "ok",
  cancelled: "muted",
};

export function orderStatusLabel(status: GarmentOrderStatus): string {
  return LABEL[status] ?? status;
}

export function orderStatusTone(status: GarmentOrderStatus): StatusTone {
  return TONE[status] ?? "muted";
}
